export default __webpack_public_path__ + "static/media/m1-1.a415f28f.png";